import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { useNavigate } from 'react-router-dom';
import Button from '../bootstrap/Button';
import Modal, { ModalHeader, ModalTitle, ModalBody, ModalFooter } from '../bootstrap/Modal';
import { signOut } from '../../api/account';
import { demoPages } from '../../menu';

const ConfirmModal = () => {
	const { show, content, title, func, size = 'sm', isStaticBackdrop = false, withoutButton = false } = useSelector((state: RootState) => state.confirm);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	function handleSetIsOpen(state: any) {
		if (state === false) {
			dispatch({
				type: 'CONFIRM_HIDE',
			});
		}
	}

	function handleSignout() {
		signOut({
			firmId: JSON.parse(localStorage.getItem('ramate_crm_auth') || '')?.firmId,
			userId: JSON.parse(localStorage.getItem('ramate_crm_auth') || '')?.userId,
			deviceId: JSON.parse(localStorage.getItem('ramate_crm_auth') || '')?.deviceId,
		})
			.then(() => {
				navigate(`../${demoPages.login.path}`);
				dispatch({ type: 'FIRM_LOGOUT' });
			})
			.catch(() => {
				navigate(`../${demoPages.login.path}`);
				dispatch({ type: 'FIRM_LOGOUT' });
			});
	}

	return (
		<Modal id='ConfirmModal' isOpen={show} setIsOpen={handleSetIsOpen} isCentered size={size} isStaticBackdrop={isStaticBackdrop}>
			<ModalHeader>
				<ModalTitle id='title'>{title}</ModalTitle>
			</ModalHeader>
			<ModalBody>{content}</ModalBody>
			<ModalFooter>
				{!withoutButton ? (
					<div className='row g-3'>
						<div className='col'>
							<Button color='primary' onClick={() => dispatch({ type: 'CONFIRM_ONCLICK' })}>
								確認
							</Button>
						</div>
						<div className='col'>
							<Button color='light' onClick={() => handleSetIsOpen(false)}>
								取消
							</Button>
						</div>
					</div>
				) : (
					<Button color='primary' onClick={() => handleSignout()}>
						登出
					</Button>
				)}
			</ModalFooter>
		</Modal>
	);
};

export default ConfirmModal;
